import { useMemo } from 'react';
import { ClientProfileViewModel } from '@common/model/client';
import { getFirstLetters } from '@cp/shared/lib/getFirstLetters';
import { getNameSurname } from '../lib';

export const useFirstLetters = (client: Pick<ClientProfileViewModel, 'name' | 'surname'>) => {
  return useMemo(() => getFirstLetters(...getNameSurname(client).split(' ')), [client]);
};
